<template>
  <div class="card" :class="{'-has-error': errors.cantFetchChartData}">
    <div class="header">
      <div class="description">
        <h2 class="title">
          Utilização por dia da semana
          <span class="errorMessage" v-if="errors.cantFetchChartData">Erro</span>
        </h2>
      </div>
    </div>

    <div class="body">
      <radar-chart-skeleton-loader v-if="loading"/>
      <apex-chart
        type="radar"
        height="350"
        :options="chartOptions"
        :series="chartSeries"
        v-else
      ></apex-chart>
    </div>
  </div>
</template>

<script>
import RadarChartSkeletonLoader from '@/support/components/loader/RadarChartSkeletonLoader.vue';
import ApexChart from 'vue-apexcharts';

export default {
  name: 'UtilizationByWeekDayRadarChart',

  props: {
    period: {
      required: true,
      type: Number,
    },
  },

  data() {
    return {
      loading: false,
      chartSeries: [],
      chartOptionsXaxisCategories: [],
      errors: {
        cantFetchChartData: false,
      },
    };
  },

  methods: {
    /**
     * Fetch the chart data.
     *
     * @returns {Promise<void>}
     */
    async fetchChartData() {
      try {
        this.resetErrors();
        this.resetChartData();
        this.loading = true;

        const { data } = await this.$http.get(`metrics/charts/utilization-by-week-day?period=${this.period}`);

        this.chartSeries = [...data.series];
        this.chartOptionsXaxisCategories = [...data.categories];
      } catch (err) {
        this.errors.cantFetchChartData = true;
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Ocorreu um erro',
          text: 'Não foi possível carregar a sua utilização por dia da semana.',
        });
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors to initial values.
     */
    resetErrors() {
      this.errors.cantFetchChartData = false;
    },

    /**
     * Reset chart data.
     */
    resetChartData() {
      this.chartSeries = [];
      this.chartOptionsXaxisCategories = [];
    },
  },

  computed: {
    chartOptions() {
      return {
        chart: {
          height: window.screen.availHeight > 768 ? 350 : 300,
          toolbar: {
            show: false,
          },
        },
        colors: ['#7366ff'],
        markers: {
          size: 6,
          colors: ['#fff'],
          strokeColor: '#7366ff',
          strokeWidth: 3,
        },
        xaxis: {
          categories: this.chartOptionsXaxisCategories,
          labels: {
            show: true,
          },
        },
      };
    },
  },

  watch: {
    period() {
      this.fetchChartData();
    },
  },

  mounted() {
    this.fetchChartData();
  },

  components: {
    ApexChart,
    RadarChartSkeletonLoader,
  },
};
</script>

<style lang="scss" scoped>

</style>
